import type { IChartType } from '@model/chartType';
import type { IInstallationPoint } from '@model/installationPoint';

export const getChartPrintTitle = (
  t: (text: string) => string,
  point: IInstallationPoint,
  chartType: IChartType,
  axisName: string,
  chartTime: string,
) => {
  return `${t('Equipment')}: ${point?.equipment?.name} ${t('Installation point')}: ${point.name}
  ${t(chartType.label)} ${chartType.unit ? '(' + chartType.unit + ')' : ''} ${
    axisName ? axisName + '-' + t('Axis') : ''
  } ${chartTime}`;
};
